import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-6" data-testid="login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-bl-surface border border-bl-border p-10">
        <img
          src="/beckyliss-logo.png"
          alt="Beckyliss Cosmetics"
          className="h-16 w-auto object-contain mb-6 mx-auto"
          data-testid="login-logo-img"
        />
        <span className="overline">Espace admin</span>
        <h1 className="font-serif text-4xl text-bl-text mt-3">Beckyliss</h1>
        <p className="text-sm text-bl-textSoft mt-2 mb-8">
          Connectez-vous pour gérer le glossaire.
        </p>
        <label className="block mb-5">
          <span className="overline block mb-2">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-transparent border-b border-bl-border focus:border-bl-dore outline-none py-2 text-bl-text"
            data-testid="login-email"
          />
        </label>
        <label className="block mb-8">
          <span className="overline block mb-2">Mot de passe</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-transparent border-b border-bl-border focus:border-bl-dore outline-none py-2 text-bl-text"
            data-testid="login-password"
          />
        </label>
        {err && (
          <p className="mb-4 text-sm text-red-700" data-testid="login-error">{err}</p>
        )}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-bl-text text-bl-bg py-3 text-sm tracking-wide hover:bg-bl-dore transition-colors disabled:opacity-50"
          data-testid="login-submit"
        >
          {loading ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
